import { VEHICLE_TYPES, type OrderStatus } from "./const.js";

/**
 * 訂單操作規則 — 純函式，前後端共用。
 */

/**
 * 是否可標示服務完成。
 * 服務日（上車時間 pickupTime）未到前不可標完成，避免調度員/供應方誤觸（P6-3）。
 * @param pickupTime 上車時間（unix ms）
 * @param now 現在時間（unix ms）
 */
export function canMarkCompleteAt(pickupTime: number, now: number): boolean {
  return now >= pickupTime;
}

/** 司機資訊回報期限：出發前 24 小時（20260611 §5） */
export const DRIVER_INFO_DEADLINE_MS = 24 * 60 * 60 * 1000;

/**
 * 司機資訊是否「逾期未回報」：active 且未填，且距出發不足 24 小時（含已出發仍未填）。
 * 用於調度員/管理員列表紅點與供應方表單紅色警示。
 */
export function isDriverInfoOverdue(
  status: OrderStatus,
  pickupTime: number,
  driverInfoSubmittedAt: number | null | undefined,
  now: number,
): boolean {
  if (status !== "active") return false;
  if (driverInfoSubmittedAt) return false;
  return pickupTime - now < DRIVER_INFO_DEADLINE_MS;
}

/**
 * 取消權限（D3）：確認售價（confirmed）後需求方不可取消，只留平台方（調度/管理員）；
 * 車隊一律不可取消。取消時間戳（cancelledAt/cancelledBy）於 service 寫入。
 */
export const AGENCY_CANCELABLE_STATUSES: OrderStatus[] = ["pending", "quoting", "quoted", "rejected_quote"];
export const PLATFORM_CANCELABLE_STATUSES: OrderStatus[] = [
  "pending",
  "quoting",
  "quoted",
  "rejected_quote",
  "confirmed",
  "dispatching",
  "rejected_dispatch",
  "active",
];

export function canCancelOrder(by: "agency" | "dispatcher" | "fleet", status: OrderStatus): boolean {
  if (by === "fleet") return false;
  return (by === "agency" ? AGENCY_CANCELABLE_STATUSES : PLATFORM_CANCELABLE_STATUSES).includes(status);
}

/**
 * 驗證人數 / 行李是否在車型容量上限內（P2-1）。
 * 未知車型不在此攔截（交由其他驗證處理）。
 */
export function validateCapacity(
  vehicleType: string,
  pax: number,
  luggage: number,
): { ok: true } | { ok: false; field: "pax" | "luggage" } {
  const v = VEHICLE_TYPES.find((x) => x.value === vehicleType);
  if (!v) return { ok: true };
  if (pax > v.maxPax) return { ok: false, field: "pax" };
  if (luggage > v.maxLuggage) return { ok: false, field: "luggage" };
  return { ok: true };
}
